import { defineMessage } from 'services/localization';

export const messages = {
    payHeader: defineMessage('pay_approved_bills_directly_from_approvalmax'),
    captureHeader: defineMessage('extract_data_from_image__no_manual_entry_needed'),
    tryNowPayButtonText: defineMessage('try_now'),
    tryNowCaptureButtonText: defineMessage('start_automating'),
    captureDescription: defineMessage('free_documents'),
};
